stimulusApp.register(
  "property-photos-preview",
  class extends Stimulus.Controller {
    static values = { url: String }

    open(event) {
      const isPlaceholder =
        event.target.style.backgroundImage?.includes("img_placeholder")
      if (!isPlaceholder) {
        this.load()
      }
    }

    load() {
      Turbo.visit(this.urlValue, { frame: "popup_modal" })
    }
  },
)
